import { AddFavoriteChannel, RemoveFavoriteChannel } from '@tableau/search-microview-communication-channels/lib/src/FavoriteChannel';

import { Favorites } from '~src/favorites/resources/Favorites';
import { FavoriteRepresentation } from '~src/favorites/resources/FavoritesResource';
import { FavoriteItemType } from '~src/favorites/types/IFavorite';

export function startListening(): () => void {
    const unsubscribeAddFavoriteListener = startListeningToAddFavoriteListener();
    const unsubscribeRemoveFavoriteListener = startListeningToRemoveFavoriteListener();

    return () => {
        unsubscribeAddFavoriteListener();
        unsubscribeRemoveFavoriteListener();
    };
}

export function startListeningToAddFavoriteListener(): () => void {
    const favoriteChannel = new AddFavoriteChannel();
    const stopListeningToFavoriteChannel = favoriteChannel.listen(request => {
        return new Promise<void>((resolve, reject) => {
            if (!MicroviewContentToVPC[request.contentType]) {
                reject();
            }

            const item = {
                contentType: MicroviewContentToVPC[request.contentType],
                contentId: request.id
            } as FavoriteRepresentation;

            Favorites.add(item.contentId, item.contentType as FavoriteItemType)
                .then(() => { resolve(); })
                .catch((e) => { reject(e); });
        });
    });

    return () => {
        stopListeningToFavoriteChannel();
    };
}

export function startListeningToRemoveFavoriteListener(): () => void {
    const favoriteChannel = new RemoveFavoriteChannel();
    const stopListeningToFavoriteChannel = favoriteChannel.listen(request => {
        return new Promise<void>((resolve, reject) => {
            if (!MicroviewContentToVPC[request.contentType]) {
                reject();
            }

            const item = {
                contentType: MicroviewContentToVPC[request.contentType],
                contentId: request.id
            } as FavoriteRepresentation;

            Favorites.remove(item.contentId, item.contentType as FavoriteItemType)
                .then(() => { resolve(); })
                .catch((e) => { reject(e); });
        });
    });

    return () => {
        stopListeningToFavoriteChannel();
    };
}

export const MicroviewContentToVPC: { [key: string]: string } = {
    collection: 'collection',
    unifieddatasource: 'datasource',
    flow: 'flow',
    project: 'project',
    virtualconnection: 'virtualConnection',
    table: 'virtualConnectionTable',
    view: 'view',
    workbook: 'workbook',
};
